// @flow
/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';

import '../../../static/scss/components/checkbox.scss';

type Props = {
  children?: string | Array<any>,
  checked?: boolean,
  readOnly?: boolean,
  labelClick?: (...args: Array<any>) => any,
  onToggle?: (...args: Array<any>) => any,
  modifier?: string | Array<any>,
  cypress?: string | null
};

type State = {
  checked: boolean
};

// props.readOnly = true, don't change state;
// labelClick - custom action for clicking on label
// onToggle - custom action for clicking on checkbox
class Checkbox extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.labelClick = this.labelClick.bind(this);
    this.state = {
      checked: false
    };
  }

  componentWillMount() {
    this.setState({
      checked: this.props.checked
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      checked: nextProps.checked
    });
  }

  labelClick() {
    const { labelClick } = this.props;
    if (labelClick) {
      labelClick();
    }
    if (!this.props.readOnly) {
      this.toggle();
    }
  }

  toggle() {
    const { checked } = this.state;
    const { onToggle } = this.props;

    if (onToggle) {
      onToggle();
    }

    if (!this.props.readOnly) {
      this.setState({
        checked: !checked
      });
    }
  }

  render() {
    const baseClassName = 'c-checkbox';
    let className = baseClassName;
    const { modifier, cypress } = this.props;

    if (modifier) {
      if (modifier.constructor === Array) {
        className = modifier.reduce(
          (acc, mod) => `${acc} ${baseClassName}--${mod}`,
          ''
        );
      } else {
        className += ` ${baseClassName}--${modifier}`;
      }
    }

    const isChecked = this.props.readOnly
      ? this.props.checked
      : this.state.checked;

    return (
      <div className={className}>
        <input type="checkbox" checked={isChecked} onChange={this.toggle} />
        <div className="c-checkbox__placeholder" onClick={this.toggle} />
        <label
          className="c-checkbox__label"
          onClick={this.labelClick}
          data-cy={cypress ? `${cypress}-checkbox-label` : null}
        >
          {this.props.children}
        </label>
      </div>
    );
  }
}

Checkbox.defaultProps = {
  checked: false,
  readOnly: false,
  children: 'label...',
  modifier: '',
  labelClick: () => {},
  onToggle: () => {},
  cypress: null
};

export default Checkbox;
